import React, { useState } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { User } from "@ecologi/shared";
import { BuyMoreImpactButton } from "./BuyMoreImpactButton";
import { ForestTitleEdit } from "./ForestTitleEdit";
import { Tooltip } from "../../Tooltip";
import { Typography } from "../../Typography";
import styles from "../styles/ForestTitleBox.module.scss";

const TitleWrapper = styled.div<{ isOwnProfile: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  z-index: 10;

  // to balance out the profile edit button
  ${(props) =>
    props.isOwnProfile &&
    css`
      padding-left: 24px;
    `}
`;

const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.snowdrop};
  word-wrap: break-word;
  max-width: 100%;
`;

export const ForestTitleBox = ({
  isOwnProfile,
  onEditTitle,
  profile,
  user,
}: {
  isOwnProfile: boolean;
  onEditTitle: (payload: any) => Promise<any>;
  profile: User;
  user: User | null;
}) => {
  const [isEditMode, setEditModeState] = useState(false);

  const isBulkParent =
    profile.username === "wearealbert" ||
    profile.parentProfile?.username === "wearealbert";
  const forestDescriptor = "impact forest";

  let forestTitle = isOwnProfile
    ? `Your ${forestDescriptor}`
    : profile.niceNamePlural + ` ${forestDescriptor}`;

  if (profile.forestName) {
    forestTitle = profile.forestName;
  } else {
    if (profile.isFamilyPlan) {
      if (isOwnProfile) {
        forestTitle = `Your family's ${forestDescriptor}`;
      } else {
        forestTitle = profile.fullNamePlural + ` ${forestDescriptor}`;
      }
    } else if (profile.isBusinessPlan || !profile.subscription) {
      forestTitle =
        profile.groupName || profile.fullNamePlural + ` ${forestDescriptor}`;
    }
  }

  if (isEditMode) {
    return (
      <ForestTitleEdit
        onEditTitle={onEditTitle}
        setEditModeState={setEditModeState}
        profile={profile}
      />
    );
  }

  return (
    <div className={styles.wrapper} id="tour-forest">
      <TitleWrapper isOwnProfile={isOwnProfile}>
        <Title use="featureTitle" as="h1">
          {forestTitle}
        </Title>
        {isOwnProfile && (
          <Tooltip content={`Change ${forestDescriptor} name`}>
            <button
              className={styles.updateButton}
              data-testid="custom-forest-name-button"
              onClick={(e) => {
                e.preventDefault();
                setEditModeState(true);
              }}
            />
          </Tooltip>
        )}
      </TitleWrapper>
      <BuyMoreImpactButton
        user={user}
        isBulkParent={isBulkParent}
        isOwnProfile={isOwnProfile}
        username={profile.username}
      />
    </div>
  );
};
